/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/** @jsx jsx */

import { css } from '@emotion/react'

export const getFontStyles = ({ euiTheme }) => css`
  @font-face {
    font-family: 'Inter UI';
    font-style: normal;
    font-weight: 100;
    src:
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-Thin-BETA.woff2') format('woff2'),
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-Thin-BETA.woff') format('woff');
  }

  @font-face {
    font-family: 'Inter UI';
    font-style: italic;
    font-weight: 100;
    src:
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-ThinItalic-BETA.woff2') format('woff2'),
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-ThinItalic-BETA.woff') format('woff');
  }

  @font-face {
    font-family: 'Inter UI';
    font-style: normal;
    font-weight: 200;
    src:
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-ExtraLight-BETA.woff2') format('woff2'),
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-ExtraLight-BETA.woff') format('woff');
  }

  @font-face {
    font-family: 'Inter UI';
    font-style: italic;
    font-weight: 200;
    src:
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-ExtraLightItalic-BETA.woff2')
        format('woff2'),
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-ExtraLightItalic-BETA.woff') format('woff');
  }

  @font-face {
    font-family: 'Inter UI';
    font-style: normal;
    font-weight: 300;
    src:
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-Light-BETA.woff2') format('woff2'),
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-Light-BETA.woff') format('woff');
  }

  @font-face {
    font-family: 'Inter UI';
    font-style: italic;
    font-weight: 300;
    src:
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-LightItalic-BETA.woff2') format('woff2'),
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-LightItalic-BETA.woff') format('woff');
  }

  @font-face {
    font-family: 'Inter UI';
    font-style: normal;
    font-weight: 400;
    src:
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-Regular.woff2') format('woff2'),
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-Regular.woff') format('woff');
  }

  @font-face {
    font-family: 'Inter UI';
    font-style: italic;
    font-weight: 400;
    src:
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-Italic.woff2') format('woff2'),
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-Italic.woff') format('woff');
  }

  @font-face {
    font-family: 'Inter UI';
    font-style: normal;
    font-weight: 500;
    src:
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-Medium.woff2') format('woff2'),
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-Medium.woff') format('woff');
  }

  @font-face {
    font-family: 'Inter UI';
    font-style: italic;
    font-weight: 500;
    src:
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-MediumItalic.woff2') format('woff2'),
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-MediumItalic.woff') format('woff');
  }

  @font-face {
    font-family: 'Inter UI';
    font-style: normal;
    font-weight: 600;
    src:
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-SemiBold.woff2') format('woff2'),
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-SemiBold.woff') format('woff');
  }

  @font-face {
    font-family: 'Inter UI';
    font-style: italic;
    font-weight: 600;
    src:
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-SemiBoldItalic.woff2') format('woff2'),
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-SemiBoldItalic.woff') format('woff');
  }

  @font-face {
    font-family: 'Inter UI';
    font-style: normal;
    font-weight: 700;
    src:
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-Bold.woff2') format('woff2'),
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-Bold.woff') format('woff');
  }

  @font-face {
    font-family: 'Inter UI';
    font-style: italic;
    font-weight: 700;
    src:
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-BoldItalic.woff2') format('woff2'),
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-BoldItalic.woff') format('woff');
  }

  @font-face {
    font-family: 'Inter UI';
    font-style: normal;
    font-weight: 800;
    src:
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-ExtraBold.woff2') format('woff2'),
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-ExtraBold.woff') format('woff');
  }

  @font-face {
    font-family: 'Inter UI';
    font-style: italic;
    font-weight: 800;
    src:
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-ExtraBoldItalic.woff2') format('woff2'),
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-ExtraBoldItalic.woff') format('woff');
  }

  @font-face {
    font-family: 'Inter UI';
    font-style: normal;
    font-weight: 900;
    src:
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-Black.woff2') format('woff2'),
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-Black.woff') format('woff');
  }

  @font-face {
    font-family: 'Inter UI';
    font-style: italic;
    font-weight: 900;
    src:
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-BlackItalic.woff2') format('woff2'),
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-BlackItalic.woff') format('woff');
  }

  @font-face {
    font-family: 'Inter UI var';
    font-weight: 100 900;
    font-style: oblique 0deg 10deg;
    src:
      url('../../../modules/cui/fonts/inter_ui/Inter-UI.var.woff2') format('woff2-variations'),
      url('../../../modules/cui/fonts/inter_ui/Inter-UI.var.woff2') format('woff2');
  }

  @font-face {
    font-family: 'Inter UI var alt';
    font-weight: 100 900;
    font-style: normal;
    font-named-instance: 'Regular';
    src:
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-upright.var.woff2')
        format('woff2 supports variations(gvar)'),
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-upright.var.woff2')
        format('woff2-variations'),
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-upright.var.woff2') format('woff2');
  }

  @font-face {
    font-family: 'Inter UI var alt';
    font-weight: 100 900;
    font-style: italic;
    font-named-instance: 'Italic';
    src:
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-italic.var.woff2')
        format('woff2 supports variations(gvar)'),
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-italic.var.woff2')
        format('woff2-variations'),
      url('../../../modules/cui/fonts/inter_ui/Inter-UI-italic.var.woff2') format('woff2');
  }

  @font-face {
    font-family: 'Roboto Mono';
    font-style: italic;
    font-weight: 400;
    src:
      local('Roboto Mono Italic'),
      local('RobotoMono-Italic'),
      url('../../../modules/cui/fonts/roboto_mono/RobotoMono-Italic.ttf') format('truetype');
    unicode-range:
      U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074,
      U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }

  @font-face {
    font-family: 'Roboto Mono';
    font-style: italic;
    font-weight: 700;
    src:
      local('Roboto Mono Bold Italic'),
      local('RobotoMono-BoldItalic'),
      url('../../../modules/cui/fonts/roboto_mono/RobotoMono-BoldItalic.ttf') format('truetype');
    unicode-range:
      U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074,
      U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }

  @font-face {
    font-family: 'Roboto Mono';
    font-style: normal;
    font-weight: 400;
    src:
      local('Roboto Mono'),
      local('RobotoMono-Regular'),
      url('../../../modules/cui/fonts/roboto_mono/RobotoMono-Regular.ttf') format('truetype');
    unicode-range:
      U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074,
      U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }

  @font-face {
    font-family: 'Roboto Mono';
    font-style: normal;
    font-weight: 700;
    src:
      local('Roboto Mono Bold'),
      local('RobotoMono-Bold'),
      url('../../../modules/cui/fonts/roboto_mono/RobotoMono-Bold.ttf') format('truetype');
    unicode-range:
      U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074,
      U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }

  /* stylelint-disable selector-max-id */
  #app-root {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .content {
    margin-top: ${euiTheme.size.m};
  }

  .fullWidth {
    margin-left: -0.625rem;
    margin-right: -0.625rem;
  }

  // smooth transition between light and dark modes
  html,
  .euiHeader,
  .euiHeaderSection,
  .euiPanel {
    transition:
      background-color ${euiTheme.animation.speedNormal} ease,
      border-color ${euiTheme.animation.speedNormal} ease;
  }

  .euiTitle,
  .euiSideNavItemButton {
    transition: color ${euiTheme.animation.speedNormal} ease;
  }

  html {
    width: 100%;
    height: 100%;
  }

  body {
    width: 100%;
    height: 100%;
  }

  del {
    text-decoration: line-through;
  }

  [data-tooltip] {
    position: relative;
  }

  [data-tooltip]::before,
  [data-tooltip]::after {
    display: none;
    pointer-events: none;
    position: absolute;
    top: 101%;
    z-index: 1000;
    opacity: 0.95;
  }

  [data-tooltip]::before {
    content: attr(data-tooltip);
    left: -0.65rem;

    padding: 0.375rem;
    white-space: nowrap;
    text-decoration: none;
    text-indent: 0;
    overflow: visible;

    font-size: 0.8em;
    font-weight: normal;
    color: ${euiTheme.colors.emptyShade};
    background-color: ${euiTheme.colors.darkestShade};
    border-radius: ${euiTheme.size.xs};
  }

  [data-tooltip]::after {
    content: '';
    left: -0.2rem;
    margin-top: -0.45rem;
    border-left: 0.45rem solid transparent;
    border-right: 0.45rem solid transparent;
    border-bottom: 0.45rem solid ${euiTheme.colors.darkestShade};
  }

  [data-tooltip-right]::before {
    top: -0.2rem;
    left: 105%;
  }

  [data-tooltip-right]::after {
    top: 0.7rem;
    right: -5%;
    border-top: 0.45rem solid transparent;
    border-bottom: 0.45rem solid transparent;
    border-right: 0.45rem solid ${euiTheme.colors.darkestShade};
  }

  [data-tooltip]:hover::before,
  [data-tooltip]:hover::after {
    display: block;
    transform: translateY(8px);
  }

  @media only print {
    [data-tooltip]::before,
    [data-tooltip]::after {
      display: none;
    }
  }

  .cloudContent {
    flex: 5;
    padding: ${euiTheme.size.xl};

    @media only screen and (max-width: ${euiTheme.breakpoint.m}px) {
      padding: ${euiTheme.size.l};
      margin-top: 0.56rem;
    }
  }

  .createPage,
  .createPage .cloudContentBody {
    @media only screen and (max-width: ${euiTheme.breakpoint.m}px) {
      padding: ${euiTheme.size.xs};
    }
  }

  .euiPageBody {
    min-height: 100%;
  }
`
